import api from '~api/api'
import { apiZodios } from '~api/apiZodios'
import outlookZodios from '~api/outlookApiZodios'
import {
  type Account,
  type ChangePasswordRequestData,
  type IApiResponse,
  type SetNotifyRequestData,
} from '~types'

import { isErrorResponse } from '../utils/utils'

export const changePassword = async (requestData: ChangePasswordRequestData): Promise<void> => {
  try {
    await api.post<IApiResponse<void>>('/core/change-password/', requestData)
  } catch (error: unknown) {
    if (isErrorResponse(error)) {
      console.error('Error updating password', error.message)
    } else {
      console.error('Error updating password', error)
    }
    throw error
  }
}

export const getAccount = async (): Promise<Account> => {
  try {
    const response = await api.post<Account>('/core/get-account/', {})
    return response.data
  } catch (error: unknown) {
    if (isErrorResponse(error)) {
      console.error('Error fetching pages', error.message)
    } else {
      console.error('Error fetching pages', error)
    }
    throw error
  }
}

export const login = async ([email, password]: [string, string]): Promise<string> => {
  try {
    const result = await apiZodios.core_userLogin({
      email,
      password,
    })
    return result.user_id || ''
  } catch (error: unknown) {
    if (isErrorResponse(error)) {
      console.error('Error logging in', error.message)
    } else {
      console.error('Error logging in', error)
    }
    throw error
  }
}

export const logout = async (userId: string): Promise<void> => {
  try {
    const isOutlook = typeof window !== 'undefined' && window.Office !== undefined
    const logoutFn = isOutlook ? outlookZodios.logout : apiZodios.core_userLogout
    await logoutFn({
      user_id: userId,
    })
    return
  } catch (error: unknown) {
    if (isErrorResponse(error)) {
      console.error('Error logging out', error.message)
    } else {
      console.error('Error logging out', error)
    }
    throw error
  }
}

export const setNotify = async (requestData: SetNotifyRequestData): Promise<void> => {
  try {
    await api.post<IApiResponse<void>>('/core/set-notify/', requestData)
  } catch (error: unknown) {
    if (isErrorResponse(error)) {
      console.error('Error setting notify', error.message)
    } else {
      console.error('Error setting notify', error)
    }
    throw error
  }
}
